/*global $*/
import React from "react";
import { connect } from "react-redux";
import { servicios } from "../properties";
import moment from "moment";

import { obtenerListaFacturas } from "./facturas.act";
import { descargas } from "../tools";

const mapDispatch = (dispatch) => {
	return {
		obtenerListaFacturas : (datos) =>{
			dispatch(obtenerListaFacturas(datos));
		},
		iniciarDescarga: () => {
			dispatch({ "type": "DOWNLOADING", "progress": 0 });
		},
		addEvento: (evento) => {
			dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": evento});
		}
	};
};

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza,
		"listaFacturas": state.polizas.listaFacturas,
		"downloadProgress": state.global.downloadProgress
	};
};

class DescargaFacturas extends React.Component {
	state = {
		"downloading": {},
		"paginas": [],
		"currentPage": 0,
		"currentMetaPage": 0
	}

	componentWillMount = () => {
		if (this.props.poliza.contratante) {
			let reqListFacturas = {
				"poliza": this.props.poliza.generales.numPoliza,
				"rfcReceptor": this.props.poliza.contratante.rfc,
				"version": this.props.poliza.generales.numVersion,
				"fechaInicio": this.props.poliza.generales.fchVigenciaInicial.split("/")[2] + this.props.poliza.generales.fchVigenciaInicial.split("/")[1] + this.props.poliza.generales.fchVigenciaInicial.split("/")[0],
				"fechaFin": this.props.poliza.generales.fchVigenciaFinal.split("/")[2] + this.props.poliza.generales.fchVigenciaFinal.split("/")[1] + this.props.poliza.generales.fchVigenciaFinal.split("/")[0],
				"ramo": this.props.poliza.generales.cveRamo
			};
			this.props.obtenerListaFacturas(reqListFacturas);
		}
	}

	calcularPaginas = () => {
		var numPaginas = 0;

		if (this.props.listaFacturas) {
			numPaginas = Math.ceil(this.props.listaFacturas.length / 6);
		}

		var paginas = [];
		for (var i = 0; i < numPaginas; i++) {
			paginas.push("");
		}
		return paginas;
	}

	goToPage = (i) => {
		this.setState({
			"currentPage": i
		});
	}

	changeMeta = (change) => {
		var currentMetaPage = this.state.currentMetaPage + change;
		this.setState({
			"currentMetaPage": currentMetaPage
		});
	}
	
	descargaFactura = (item) => {
		let filename = "Factura_" + moment(item.fechaEmision, "YYYY-MM-DD").format("L");

		var page_url_pdf = servicios.facturas.descargaFactura + "?idDocumento=" + item.id + "&tipo=pdf";
		var page_url_xml = servicios.facturas.descargaFactura + "?idDocumento=" + item.id + "&tipo=xml";

		descargas(page_url_pdf, filename + ".pdf");
		descargas(page_url_xml, filename + ".xml");
		
		this.props.addEvento("DescargaFacturas");
	}

	close = () => {
		$("#modal-" + this.props.modal).modal("toggle");
	} 

	render() {
		return (
			<div className="mt-34">
				<div className="modal-container">
					<h5 className="pd-lr-30">Facturas <button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close"><img src={ require("../img/x.svg") } alt="" /></button></h5>
					<hr className="mt-34" />
					<div className="row">
						<div className="col-xs-12 col-md-10 col-md-offset-1">
							<p className="text-center">En esta sección podrás visualizar las facturas asociadas a tu póliza en formato pdf y xml. Haz clic en el icono de descarga para guardar o imprimir.</p>
							<div className="row">
								<div className="col-sm-12">
									<table className="table table-striped table-center mt-34 tabla-facturas">
										<thead>
											<tr>
												<th>Factura</th>
												<th>PDF/XML</th>
											</tr>
										</thead>
										<tbody>
											{ this.props.listaFacturas && this.props.listaFacturas.map((item,i) =>
												<tr key={i} className={Math.floor(i / 6) == this.state.currentPage ? "show-tr" : "hide"}>
													<td style={{ "textAlign": "left !important" }}>{moment(item.fechaEmision, "YYYY-MM-DD").format("LL")}</td>
													<td>
														<a onClick={this.descargaFactura.bind(this, item)} >
															{ !(this.state.downloading[item.id+"pdf"] || this.state.downloading[item.id+"xml"]) &&
                                                            <img src={ require("../img/icon-dowload.svg") }/>
															}
															{ (this.state.downloading[item.id+"pdf"] || this.state.downloading[item.id+"xml"]) &&
                                                            <img style={{ "height": "19px", "width": "19px" }} src={require("../img/load_mini.gif")} />
															}
														</a>
													</td>
												</tr>
											)}
										</tbody>
									</table>
									<div className="text-center paginador mt-50">
										<ul className="clearfix">
											<li className={this.state.currentPage > 6 ? "show-li" : "hide"}>
												<a onClick={this.changeMeta.bind(this, -1)}>
													<img src={ require("../img/flecha-izquierda.svg") } />
												</a>
											</li>
											{ this.calcularPaginas().map((item, i) =>
												<li key={i} className={Math.floor(i / 6) == this.state.currentMetaPage}>
													<a className={this.state.currentPage == i ? "orange-text" : ""} onClick={this.goToPage.bind(this, i)}>{i + 1}</a>
												</li>
											)}
											<li className={this.calcularPaginas() > 6 ? "show-li" : "hide"}>
												<a onClick={this.changeMeta.bind(this, 1)}>
													<img src={ require("../img/flecha-abajo.svg") } />
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);

	}
}
export default connect(mapState,mapDispatch)(DescargaFacturas);



// WEBPACK FOOTER //
// ./src/home/descargaFacturas.cmpt.js